<r-widget-control [control]="firstnameControl">
  <nz-radio-group
    [name]="config.name"
    [(ngModel)]="config.value"
    (ngModelChange)="onChange($event)"
    [required]="config.required"
    [disabled]="config.disabled"
    ngDefaultControl
    #firstnameControl="ngModel"
  >
    <ng-container *ngFor="let item of config.dataSource">
      <label nz-radio [nzValue]="item.value">{{ item.label }}</label>
    </ng-container>
  </nz-radio-group>
</r-widget-control>
